import { styled, TableCell } from '@mui/material';

export const BorderlessTableCell = styled(TableCell)({
  border: 'none',
  padding: '4px 0',
});
